module.exports = __webpack_public_path__ + "img/loyalty_stamp.ff317b6a.png";